(function () {
  if (window.WoodarqStillNeedHelp && window.WoodarqStillNeedHelp.initAll) {
    window.WoodarqStillNeedHelp.initAll();
    return;
  }

  var ROOT_SELECTOR = '[data-woodarq-help-section]';
  var REVEAL_SELECTOR = '[data-help-reveal]';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function splitWords(el) {
    if (!el || el.__waHelpSplitReady) return;
    el.__waHelpSplitReady = true;

    var source = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!source) return;

    var words = source.split(' ');
    el.textContent = '';

    words.forEach(function (word, index) {
      var span = document.createElement('span');
      span.className = 'wa-help-word';
      span.style.setProperty('--wa-help-word-index', index);
      span.textContent = word;
      el.appendChild(span);
      if (index < words.length - 1) {
        el.appendChild(document.createTextNode(' '));
      }
    });
  }

  function prepareText(root) {
    if (prefersReducedMotion()) return;

    var revealElements = toArray(root.querySelectorAll(REVEAL_SELECTOR));

    revealElements.forEach(function (el, index) {
      if (!el.style.getPropertyValue('--wa-help-delay')) {
        el.style.setProperty('--wa-help-delay', Math.min(index * 140, 420) + 'ms');
      }

      if (el.hasAttribute('data-help-split')) {
        splitWords(el);
      }
    });
  }

  function markVisible(root) {
    if (!root) return;
    root.classList.add('is-visible');
    if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
      window.ScrollTrigger.refresh();
    }
  }

  function setupObserver(root) {
    if (!root || root.__waHelpObserverBound) return;
    root.__waHelpObserverBound = true;

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      markVisible(root);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        markVisible(root);
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.2,
      rootMargin: '0px 0px -10% 0px'
    });

    observer.observe(root);
  }

  function initRoot(root) {
    if (!root) return;
    prepareText(root);
    setupObserver(root);
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    toArray(container.querySelectorAll(ROOT_SELECTOR)).forEach(initRoot);
  }

  window.WoodarqStillNeedHelp = {
    initAll: initAll,
    initRoot: initRoot
  };

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  window.addEventListener('load', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  initAll();
})();
